<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
}
.option-inner-wrap li {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

#page-user-list .ag-header-cell,
#page-user-list .ag-cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
#page-user-list .freez-action-col {
  padding-left: 10px;
}
.track-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.track-select {
  width: 85%;
  margin-right: 15px;
}
.input-track-name {
  width: 75%;
  margin-right: 15px;
}
.add-track-inner-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.datewrap input {
  width: 100%;
}
.header-custome span {
  font-size: 15px;
}

.blank-attendee {
  height: 732px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.entity-create-sec {
  text-align: center;
}
.entity-setup-buttons button {
  margin: 25px 7px 0;
}
.new-entity-add-button {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
.emtity-icon span svg {
  display: inline-block;
  height: 100px;
  width: 100px;
}
.emtity-icon {
  height: 200px;
  width: 290px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  overflow: hidden;
}
.emtity-icon img {
  max-width: 100%;
  height: 100%;
}
.entity-create-desc p {
  width: 480px;
  margin: 0 auto;
}
.meeting-setting-popup.con-vs-popup .vs-popup {
  width: 50% !important;
}
.knowlg-base-wrap-sec span {
    display: inline-block;
    background: #fff;
    padding: 5px 8px;
    border-radius: 5px;
    box-shadow: 0 0 8px rgba(0,0,0,0.1);
}
.userlist-popup .vs-popup {
  width: 70%;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        One to One Meetings
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <span class="ml-3 text-default h3"
          >Total: {{ meetingData.length }}</span
        >
        <span class="ml-3 text-success h3"
          >Confirmed: {{ meetingCountData.Accepted.length }}</span
        >
        <span class="ml-3 text-success h3"
          >Attended: {{ meetingCountData.Attended }}</span
        >
        <span class="ml-3 text-primary h3"
          >Pending: {{ meetingCountData.Pending.length }}</span
        >
        <span class="ml-3 text-warning h3"
          >Canceled: {{ Number(meetingCountData.Canceled.length)+Number(meetingCountData.Rejected.length) }}</span
        >
        <!-- <span class="ml-3 text-danger h3">Rejected: {{ meetingCountData.Rejected.length }}</span> -->
        <!-- <a href="/pages/knowledge-base/category-meetings/question-2"
          ><span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line></svg
          ></span>
          Need help with this section?</a
        > -->
      </div>
    </div>
    <div class="vx-card p-6 blank-attendee" v-show="meetingData.length < 1">
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <!--<feather-icon class="" icon="UserCheckIcon" />-->
          <img src="../../assets/images/blank-page-images/1to1-meeting.png" />
        </div>
        <div class="entity-create-desc">
          <h2>Enable 1:1 Meetings</h2>
          <p>
            By enabling the one to one meeting, attendees are able to initiate
            one-on-one video calls with other attendees as per the confirmed
            meeting slots booked in advance.
          </p>
          <div class="entity-setup-buttons">
            <vs-button color="primary" type="filled" @click="getDefaultSettings"
              >ADVANCED SETTINGS</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="popupActive = true"
              >IMPORT</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card p-6" v-show="meetingData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  meetingData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : meetingData.length
                }}
                of {{ meetingData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->
        <!-- <vs-button class="mr-4" v-on:click="attendessList=[];popupUserList = true">User List</vs-button> -->
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0 mr-2" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->

        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu class="dropdown-width">
            <vs-dropdown-item @click="exportSelected">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Export</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="exportAttendance">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Meeting Attendance Report</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="attendessList=[];popupUserList = true">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Generate Zoom Meeting</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="deleteRecord()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Record(s)</span>
              </span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="deleteRecord2()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Temp Record(s)</span>
              </span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
        <vs-button
          color="primary"
          type="border"
          class="ml-3"
          icon="upload"
          @click="popupActive = true"
        ></vs-button>
        <vs-popup
          class="holamundo meeting-setting-popup"
          title="Meeting Settings"
          :active.sync="popupActive2"
        >
          <!-- <meeting-settings :data="settingsData" /> -->
          <div id="meeting-settings">
            <!-- Content Row -->
            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full">
                <!-- <vs-button
                  color="warning"
                  type="filled"
                  icon="delete"
                  class="ml-auto mt-2"
                  :disabled="meetingData.length ? true : false"
                  @click="ClearAttendeeSlots"
                >
                  Clear Attendee Slots
                </vs-button> -->
              </div>
            </div>
            <vs-tabs position="left">
              <vs-tab label="General">
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <label>
                      Slot (Min)
                      <span class="rqrd">*</span>
                    </label>
                    <vs-input
                      :disabled="meetingData.length ? true : false"
                      class="w-full"
                      type="number"
                      name="Slot"
                      v-model="settingsData.Slot"
                      v-validate="'required'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Slot')"
                      >{{ errors.first("Slot") }}</span
                    >
                  </div>

                  <div class="vx-col md:w-1/2 w-full mt-4 datewrap">
                    <label>Button Label</label>
                    <vs-input
                      class="inputx time-pkr w-full"
                      placeholder="Button Label"
                      v-model="settingsData.ButtonLabel"
                    />
                  </div>
                  <div
                    class="vx-col md:w-1/2 w-full mt-4"                    
                  >
                    <label>Excluded Groups</label>
                    <v-select
                      v-model="settingsData.ExcludeGroupToRequestMeeting"
                      :options="GroupList"
                      label="GroupName"
                      name="Groups"
                    />
                  </div>
                  <div
                    class="vx-col md:w-1/2 w-full mt-4"                    
                  >
                    <label>Meeting Restriction Enabled</label>
                    <vs-switch
                      v-model="settingsData.MeetingRestrictionEnabled"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mt-4">
                    <label>Streaming Client</label>
                    <div class="w-full mt-5">
                      <vs-radio
                        v-model="settingsData.StreamingClient"
                        vs-value="Web"
                        name="StreamingClient"
                        >Web</vs-radio
                      >
                      <vs-radio
                        class="ml-3"
                        v-model="settingsData.StreamingClient"
                        vs-value="Zoom"
                        name="StreamingClient"
                        >Zoom</vs-radio
                      >
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-4">
                    <label>Book Meeting URL</label>
                      <v-select
                        :clearable="false"
                        class="track-select"
                        label="PageUrl"
                        v-model="settingsData.BookMeetingURL"
                        :options="AvailableMenu"
                        :reduce="item => item.PageUrl"
                      />
                  </div>
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <label>Location</label>
                    <div class="track-wrapper">
                      <v-select
                        :disabled="meetingData.length ? true : false"
                        class="track-select"
                        label="LocationName"
                        v-model="settingsData.Location"
                        :options="LocationList"
                      />
                      <vs-button
                        color="primary"
                        type="filled"
                        @click="
                          popupActive2 = false;
                          popupActive3 = true;
                        "
                        >Add</vs-button
                      >
                      <div class="track-popup">
                        <vs-popup
                          class="holamundo"
                          title="Add Location"
                          :active.sync="popupActive3"
                        >
                          <div class="add-track-inner-section">
                            <vs-input
                              class="inputx input-track-name"
                              v-model="LocationName"
                            />
                            <vs-button
                              color="rgb(76, 139, 246)"
                              type="filled"
                              @click="addLocation"
                              >Add</vs-button
                            >
                          </div>
                        </vs-popup>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Slots">
                <div class="mb-2" v-for="(slot,findex) in Items" :key="findex">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full datewrap">
                        <label>Start Date <span class="rqrd">*</span></label>
                        <flat-pickr
                          :disabled="slot.ReadOnlyField ? true : false"
                          :config="configdateTimePickerStart"
                          :name="`StartDate-${findex}`"
                          v-model="slot.StartDateShow"
                          v-validate="'required'"
                          placeholder="Start Date"
                          class="time-pkr"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`StartDate-${findex}`)"
                          >This field is required</span
                        >
                      </div>
                      <div class="vx-col md:w-1/2 w-full datewrap">
                        <label>End Date <span class="rqrd">*</span></label>
                        <flat-pickr
                          :disabled="slot.ReadOnlyField ? true : false"
                          :config="configdateTimePickerEnd"
                          :name="`EndDate-${findex}`"
                          v-model="slot.EndDateShow"
                          v-validate="'required'"
                          placeholder="End Date"
                          class="time-pkr"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`EndDate-${findex}`)"
                          >This field is required</span
                        >
                      </div>
                      <div class="vx-col md:w-1/2 w-full mt-4 datewrap">
                        <label>
                          Availability From Time
                          <span class="rqrd">*</span>
                        </label>

                        <flat-pickr
                          :disabled="slot.ReadOnlyField ? true : false"
                          :config="configdateTimePickerTime"
                          :name="`AvailabilityFromTime-${findex}`"
                          v-model="slot.AvailabilityFromTime"
                          v-validate="'required'"
                          class="time-pkr"
                        />

                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`AvailabilityFromTime-${findex}`)"
                          >This field is required</span
                        >
                      </div>
                      <div class="vx-col md:w-1/2 w-full mt-4 datewrap">
                        <label>
                          Availability To Time
                          <span class="rqrd">*</span>
                        </label>
                        <flat-pickr
                          :disabled="slot.ReadOnlyField ? true : false"
                          :config="configdateTimePickerTime"
                          :name="`AvailabilityToTime-${findex}`"
                          v-model="slot.AvailabilityToTime"
                          v-validate="'required'"
                          class="time-pkr"
                        />

                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`AvailabilityToTime-${findex}`)"
                          >This field is required</span
                        >
                      </div>  
                      <div class="vx-col w-full md:w-1/1 mt-4">
                        <div class="flex flex-wrap items-center justify-end">
                          <feather-icon class="cursor-pointer w-5 h-5 text-success" @click="addRow(findex)" icon="PlusIcon" v-show="findex+1==Items.length" />  
                          <feather-icon class="cursor-pointer w-5 h-5 text-danger ml-auto" icon="TrashIcon" v-show="Items.length > 1 && !slot.ReadOnlyField" @click="Items.splice(findex, 1);" /> 
                        </div>                   
                      </div>               
                    </div>
                  </vx-card>
                </div>
              </vs-tab>
              <!-- <vs-tab label="Notification">
                <div class="vx-row hidden">
                  <div class="vx-col md:w-8/12 mt-5">
                    <label>Meeting Starting Soon</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Message"
                      v-model="settingsData.NotificationMessage[0].Message"
                    />
                  </div>

                  <div class="vx-col md:w-4/12 mt-5">
                    <label>Notify Before (Min)</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Notify Before"
                      v-model="settingsData.NotificationMessage[0].NotifyBefore"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col md:w-12/12 w-full mt-5">
                    <label>New Meeting Request</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Message"
                      v-model="settingsData.NotificationMessage[1].Message"
                    />
                  </div>

                  <div class="vx-col md:w-12/12 w-full mt-5">
                    <label>Meeting Joined</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Message"
                      v-model="settingsData.NotificationMessage[2].Message"
                    />
                  </div>

                  <div class="vx-col md:w-12/12 w-full mt-5">
                    <label>Meeting Declined</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Message"
                      v-model="settingsData.NotificationMessage[3].Message"
                    />
                  </div>
                  <div class="vx-col md:w-12/12 w-full mt-5">
                    <label>Meeting Accepted</label>
                    <vs-input
                      class="inputx w-full"
                      placeholder="Message"
                      v-model="settingsData.NotificationMessage[4].Message"
                    />
                  </div>
                </div>
              </vs-tab> -->
            </vs-tabs>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-10 flex flex-wrap items-center justify-end">
                  <vs-button
                    class="ml-auto mt-2"
                    @click="before_save"
                    :disabled="!validateForm"
                    >Save Changes</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-popup
      class="holamundo userlist-popup"
      title="User List"
      :active.sync="popupUserList"
    >
      <div
        class="
          vx-col
          flex
          justify-content-between
          align-items-center
          w-full
          text-right
          mb-5
          event-admin-popup-header
        "
      >
        <vs-input
          label="Search Attendees By Name, Email"
          class="inputx w-full md:w-6/12"
          placeholder="Enter First Name, Last Name, Full Name or Email"
          v-model="searchAttendeeText"
          v-on:keyup.enter="getAttendees"
        />
        <vs-button class="ml-2" @click="getAttendees">Search</vs-button>        
      </div>
      <div class="flex flex-wrap">
        <div class="flex-grow">
          <div>
            <vs-table :data="attendessList">
              <template slot="thead">
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Email</vs-th>
                <vs-th>Convert All Meeting to Zoom</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].FirstName">{{
                    data[indextr].FirstName
                  }}</vs-td>
                  <vs-td :data="data[indextr].LastName">{{
                    data[indextr].LastName
                  }}</vs-td>
                  <vs-td :data="data[indextr].Email">{{
                    data[indextr].Email
                  }}</vs-td>
                  <vs-td :data="data[indextr].AttendeeId">
                    <vs-button v-if="tr.Meetings.length" @click="convertZoomMeeting(tr.Meetings)">Convert</vs-button>
                    <vs-button v-else disabled color="warning">No Meetings</vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="meetingData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup
      class="holamundo"
      title="Import Meetings"
      :active.sync="popupActive"
    >
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn"
            href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Meeting.xlsx?alt=media&token=891d1314-5eab-4d95-8fa3-f81afd2259a1"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Select XLSX file</p>
            <input
              type="file"
              id="meeting_file"
              accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)"
              type="filled"
              class="sub-btn"
              v-on:click="UploadMeetings"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// Store Module
import moduleMeetingManagement from "@/store/meeting-management/moduleMeetingManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

import MeetingSettings from "./MeetingSettings.vue";

//console.log(db);
//const event_collectionName = 'sayek-dev';
import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

var self;
var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    MeetingSettings,
  },
  data() {
    return {
      gridSelectedRows: 0,
      meetingList: null,
      popupActiveExport: false,
      popupActive3: false,
      LocationList: [],
      GroupList: [],
      attendeeData: [],
      LocationName: null,
      pageLoaded: false,
      Items:[
          {
            StartDateShow: null,
            EndDateShow: null,            
            AvailabilityFromTime: 0,
            AvailabilityToTime: 0
          }
        ],
      settingsData: {
        //AvailabilityFromTime: 0,
        //AvailabilityToTime: 0,
        ButtonLabel: "Request Meeting",
        ByTimezone: true,
        //EndDate: null,
        //StartDate: null,
        Location: null,
        Slot: 30,
        ExcludeGroupToRequestMeeting: null,
        MeetingRestrictionEnabled: false,
        AvailableMenu: [],
        BookMeetingURL: '/attendee',
        StreamingClient: 'Web',   
        NotificationMessage: [
          {
            Message:
              "Your meeting is about to start with {{MeetingJoinee}}. Join now {{MyMeetings}}",
            Name: "Meeting Starting Soon",
            NotifyBefore: 30,
          },
          {
            Message: "You have a new meeting request from {{MeetingRequestor}}",
            Name: "New Meeting Request",
          },
          {
            Message:
              "{{MeetingJoinee}} has Joined the meeting, Join Now {{MyMeetings}}",
            Name: "Meeting Joined",
          },
          {
            Message: "{{MeetingReceiver}} has declined your meeting request",
            Name: "Meeting Declined",
          },
          {
            Message: "{{MeetingReceiver}} has accepted your meeting request",
            Name: "Meeting Accepted",
          },
        ],
      },
      StartDate: null,
      EndDate: null,
      AvailabilityFromTime: null,
      AvailabilityToTime: null,
      configdateTimePickerStart: {
        //minDate: new Date(),
        //maxDate: null,
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerEnd: {
        //minDate: new Date(),
        //maxDate: null,
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerTime: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      IsDefaultSettings: false,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      popupUserList: false,
      attendessList: [],
      searchAttendeeText: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          filter: false,
          width: 50,
          pinned: "left",
        },
        {
          headerName: "Meeting Id",
          field: "MeetingId",
          hide: true,
          width: 150,
          filter: true,
          pinned: "left",
        },
        {
          headerName: "Requested By",
          field: "Requestor.Name",
          width: 200,
          filter: true,
          //pinned: "left",
        },
        /*{
          headerName: "Requested Email",
          field: "Requestor.Email",
          width: 200,
          filter: true,
          //pinned: "left",
        },
        {
          headerName: "Requestor Type",
          field: "RequestorType",
          width: 200,
          filter: true,
          //pinned: "left",
        },*/
        {
          headerName: "Requested To",
          field: "Invitee.Name",
          width: 200,
          filter: true,
          //pinned: "left",
        },
        /*{
          headerName: "Invitee Email",
          field: "Invitee.Email",
          width: 200,
          filter: true,
          //pinned: "left",
        },
        {
          headerName: "Invitee Type",
          field: "InviteeType",
          width: 200,
          filter: true,
          //pinned: "left",
        },*/
        {
          headerName: "Meeting Date&Time",
          field: "Slots",
          width: 150,          
          filter: true,
          cellRenderer: (data) => {
            return data.value ? moment(data.value[0]).format("MM/DD/YYYY H:mm") : 'N/A';
          },
        }, 
        {
          headerName: "Streaming CLient",
          field: "StreamingClient",
          width: 200,
          cellStyle: { "text-align": "center" },          
          filter: true,
          cellRenderer: (data) => {
            return data.value ? data.value : 'Web';
          },
        },       
        {
          headerName: "Created On",
          field: "CreateDateTime",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value._seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          //width: 100,
          filter: true,
        },
        {
          headerName: "Status",
          field: "Status",
          //width: 100,
          cellRenderer: (data) => {
            return data.value == "Accepted" ? '<span class="text-success">Confirmed</span>' : data.value;
          },
          filter: true,
        },
        {
          headerName: "Attended",
          field: "Attended",
          //width: 100,
          filter: true,
          cellRenderer: (data) => {
            return data.value ? '<span class="text-success">YES</span>' : '<span class="text-warning">NOT YET</span>';
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          //width: 100,
          //hide: true,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              id: params.data.MeetingId,
              Name: params.data.AttendeeName,
              Status: params.data.Status,
            };
          },
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {},
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    meetingData() {
      /*let attendessList = this.$store.state.attendeeManagement.attendees;
      this.$store.state.meetingManagement.meetings.filter(item=>{
        let index = attendessList.findIndex(a=> item.Requestor.AttendeeId && item.Requestor.AttendeeId == a.AttendeeId)
        let index2 = attendessList.findIndex(a=> item.Invitee.AttendeeId && item.Invitee.AttendeeId == a.AttendeeId)
        if(index >= 0 && attendessList[index].RegistrationType){
          if(typeof attendessList[index].RegistrationType == 'object') 
            item.RequestorType = attendessList[index].RegistrationType.RegistrationType
          else
            item.RequestorType = attendessList[index].RegistrationType
        } else 
          item.RequestorType = 'N/A';
        if(index2 >= 0 && attendessList[index2].RegistrationType){
          if(typeof attendessList[index2].RegistrationType == 'object')
            item.InviteeType = attendessList[index2].RegistrationType.RegistrationType
          else
            item.InviteeType = attendessList[index2].RegistrationType
        } else 
          item.InviteeType = 'N/A';
      }) */
      return this.$store.state.meetingManagement.meetings;
    },
    meetingCountData() {
      return {
        Attended: this.$store.state.meetingManagement.Attended,
        Accepted: this.$store.state.meetingManagement.Accepted,
        Canceled: this.$store.state.meetingManagement.Canceled,
        Pending: this.$store.state.meetingManagement.Pending,
        Rejected: this.$store.state.meetingManagement.Rejected,
      };
    },
    /*usersData () {
      return this.$store.state.userManagement.users
    },*/
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  methods: {
    fetchAttendeeData() {
      var cn = ls.getSessionEventCollectionName();
      con.eventDB
        .collection(cn)
        .doc("AttendeeList")
        .collection("Attendees")
        .get()
        .then((querySnapshot) => {
          querySnapshot.docs.forEach((doc) => {
            let docObj = doc.data();
            this.attendeeData.push(docObj);
          });
        });
    },
    exportChat() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      debugger;
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      console.log(cn);

      if (selectedRows.length > 0) {
        selectedRows.map((row) => {
          console.log(row.MeetingId);
          var ref = con.eventDB
            .collection(cn)
            .doc("UserVideoActivity")
            .collection("OneToOneMeeting")
            .doc(row.MeetingId)
            .collection("Chat");
          console.log(ref);

          ref.get().then((querySnapshot) => {
            var datarow = [];

            datarow.push("ChatId");
            datarow.push("Name");
            datarow.push("Message");
            datarow.push("SentTime");
            var MeetingChatData = [];
            MeetingChatData.push(datarow);
            console.log("MeetingChatData - " + MeetingChatData);

            //-----------------------------------------------------------------------------------------------------------------------

            querySnapshot.forEach((doc) => {
              debugger;
              datarow = [];
              var ChatId =
                doc.data().ChatId == undefined ? "" : doc.data().ChatId;
              datarow.push('"' + ChatId + '"');
              var userName = (
                doc.data().Name == undefined ? "" : doc.data().Name.toString()
              ).trim();
              datarow.push('"' + userName + '"');
              var Msg = (
                doc.data().Message == undefined
                  ? ""
                  : doc
                      .data()
                      .Message.toString()
                      .split("#")
                      .join("")
                      .split(",")
                      .join("")
              ).trim();
              datarow.push('"' + Msg + '"');
              var SentTime =
                doc.data().CreatedDate == undefined ||
                doc.data().CreatedDate == null
                  ? "NA"
                  : this.SetTimeByZoneAMPM(
                      new Date(
                        doc.data().CreatedDate.seconds * 1000
                      ).toUTCString(),
                      Session_Event_TZ
                    );

              datarow.push(
                SentTime.replace(",", "").replace(",", "").replace(",", "")
              );
              MeetingChatData.push(datarow);
              debugger;
            });

            //------------------------------------------------------------------------------------------------------------------------
            // debugger;
            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            MeetingChatData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            console.log(csvContent);
            var filename = "OneToOneChat_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
          });
        });

        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one record to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var dte = dt.getDate();
      var mnth = dt.getMonth();
      var yr = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes;
      if (minutes != "00" && parseInt(minutes) < 10) {
        minutes = "0" + minutes;
      }
      var formattedtime =
        dte.toString() +
        "/" +
        mnth.toString() +
        "/" +
        yr.toString() +
        "  " +
        hours.toString() +
        ":" +
        minutes.toString() +
        " " +
        amPM;
      //return formattedtime;
      return formattedtime;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    SetTimeByZoneAMPM: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    getTimeFromSecond: function (given_seconds) {
      let dateObj = new Date(given_seconds * 1000);
      let hours = dateObj.getUTCHours();
      let minutes = dateObj.getUTCMinutes();
      let seconds = dateObj.getSeconds();

      let timeString =
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0");
      return timeString;
    },
    UploadMeetings: function () {
      var files = document.getElementById("meeting_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "meeting");
    },
    fetch_meetingLocation() {
      this.$store.dispatch("meetingManagement/fetchLocations").then((res) => {
        this.LocationList = res;
      });
    },
    addLocation() {
      /* eslint-disable */
      if (!this.LocationName) return;
      this.$vs.loading();
      this.$store
        .dispatch("meetingManagement/addLocation", {
          LocationName: this.LocationName,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Meeting Location",
            text: res.message,
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            this.LocationName = "";
            this.popupActive3 = false;
            //this.fetch_meetingLocation();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    addRow(index){      
      let rowObj = {
        ReadOnlyField: false,
        StartDateShow: null,
        EndDateShow: null,            
        AvailabilityFromTime: 0,
        AvailabilityToTime: 0
      }
      this.Items.splice(Number(index+1), 0, rowObj);
      //console.log(this.Items)
    },
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.getSettings();
      /*this.settingsData = {
        AvailabilityFromTime: 0,
        AvailabilityToTime: 0,
        ButtonLabel: "Request Meeting",
        ByTimezone: true,
        EndDate: null,
        StartDate: null,
        Location: null,
        Slot: 30,
        ExcludeGroupToRequestMeeting: null,
        MeetingRestrictionEnabled: false,
        Items:[
          {
            StartDate: null,
            EndDate: null,            
            AvailabilityFromTime: 0,
            AvailabilityToTime: 0
          }
        ],
        NotificationMessage: [
          {
            Message:
              "Your meeting is about to start with {{MeetingJoinee}}. Join now {{MyMeetings}}",
            Name: "Meeting Starting Soon",
            NotifyBefore: 30,
          },
          {
            Message: "You have a new meeting request from {{MeetingRequestor}}",
            Name: "New Meeting Request",
          },
          {
            Message:
              "{{MeetingJoinee}} has Joined the meeting, Join Now {{MyMeetings}}",
            Name: "Meeting Joined",
          },
          {
            Message: "{{MeetingReceiver}} has declined your meeting request",
            Name: "Meeting Declined",
          },
          {
            Message: "{{MeetingReceiver}} has accepted your meeting request",
            Name: "Meeting Accepted",
          },
        ],
      };
      this.popupActive2 = true;*/
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.popupActive3 = false;
      this.$store.dispatch("meetingManagement/getSettings").then((res) => {
        if (res) {
          this.settingsData = res;
          this.settingsData.Slot = res.Duration;
          this.settingsData.ExcludeGroupToRequestMeeting = res.ExcludeGroupToRequestMeeting ? res.ExcludeGroupToRequestMeeting : null;
          this.settingsData.MeetingRestrictionEnabled = res.MeetingRestrictionEnabled ? res.MeetingRestrictionEnabled : false;  
          this.settingsData.BookMeetingURL = res.BookMeetingURL ? res.BookMeetingURL : '/attendee';  
          this.settingsData.StreamingClient = res.StreamingClient ? res.StreamingClient : 'Web';  

          if(res.Items && res.Items.length){            
            res.Items.forEach(item=>{
              item.ReadOnlyField = vm.meetingData.length ? true : false;
              item.StartDateShow = item.StartDate
                ? this.SetTimeByZone(
                    new Date(item.StartDate._seconds * 1000).toUTCString(),
                    Intl.DateTimeFormat().resolvedOptions().timeZone
                  )
                : null;
              item.EndDateShow = item.EndDate
                ? this.SetTimeByZone(
                    new Date(item.EndDate._seconds * 1000).toUTCString(),
                    Intl.DateTimeFormat().resolvedOptions().timeZone
                  )
                : null;
              item.AvailabilityFromTime = item.AvailabilityFromTime
                ? this.getTimeFromSecond(item.AvailabilityFromTime)
                : "00:00";
              item.AvailabilityToTime = item.AvailabilityToTime
                ? this.getTimeFromSecond(item.AvailabilityToTime)
                : "00:00";
            });
            this.Items = res.Items
          }else{
            this.Items = [
              {
                ReadOnlyField: vm.meetingData.length ? true : false,
                StartDateShow: res.StartDate
                  ? this.SetTimeByZone(
                      new Date(res.StartDate._seconds * 1000).toUTCString(),
                      Intl.DateTimeFormat().resolvedOptions().timeZone
                    )
                  : null,
                EndDateShow: res.EndDate
                  ? this.SetTimeByZone(
                      new Date(res.EndDate._seconds * 1000).toUTCString(),
                      Intl.DateTimeFormat().resolvedOptions().timeZone
                    )
                  : null,
                AvailabilityFromTime: res.AvailabilityFromTime
                  ? this.getTimeFromSecond(res.AvailabilityFromTime)
                  : "00:00",
                AvailabilityToTime: res.AvailabilityToTime
                  ? this.getTimeFromSecond(res.AvailabilityToTime)
                  : "00:00"
              }
            ]
          }
          

          if (res.NotificationMessage) {
          } else {
            this.settingsData.NotificationMessage = [
              {
                Message:
                  "Your meeting is about to start with {{MeetingJoinee}}. Join now {{MyMeetings}}",
                Name: "Meeting Starting Soon",
                NotifyBefore: 30,
              },
              {
                Message:
                  "You have a new meeting request from {{MeetingRequestor}}",
                Name: "New Meeting Request",
              },
              {
                Message:
                  "{{MeetingJoinee}} has Joined the meeting, Join Now {{MyMeetings}}",
                Name: "Meeting Joined",
              },
              {
                Message:
                  "{{MeetingReceiver}} has declined your meeting request",
                Name: "Meeting Declined",
              },
              {
                Message:
                  "{{MeetingReceiver}} has accepted your meeting request",
                Name: "Meeting Accepted",
              },
            ];
          }
        }
        //this.settingsData.meetingList = this.meetingData
        this.popupActive2 = true;

        this.$vs.loading.close();
      });
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    ClearAttendeeSlots() {
      if (confirm("Are you sure want to delete!")) {
        this.$vs.loading();
        this.$store
          .dispatch("meetingManagement/clearAttendeeSlots", {
            settingsData: this.settingsData,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Settings",
              text: "Attendee meeting slots removed.",
            });
            this.$vs.loading.close();
          });
      }
    },
    save_changes() {
      /* eslint-disable */
      //console.log(this.data_local)
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      //this.settingsData.ByTimezone = true;
      /*this.settingsData.Duration = this.settingsData.Slot;
      delete this.settingsData.Slot;
      delete this.settingsData.Slots;*/
      /*this.settingsData.StartDate = this.GetTimeByZone(
        this.StartDate,
        Session_Event_TZ
      );
      this.settingsData.EndDate = this.GetTimeByZone(
        this.EndDate,
        Session_Event_TZ
      );*/
      let StartDate = moment(this.Items[0].StartDateShow).format("YYYY-MM-DD");
      let EndDate = moment(this.Items[0].EndDateShow).format("YYYY-MM-DD");

      let a = this.Items[0].AvailabilityFromTime.split(":");
      let AvailabilityFromTime = +a[0] * 60 * 60 + +a[1] * 60;
      let b = this.Items[0].AvailabilityToTime.split(":");
      let AvailabilityToTime = +b[0] * 60 * 60 + +b[1] * 60;


      let Items = this.Items.map(item=>{
        let itm = {}
        itm.StartDate = moment(item.StartDateShow).format("YYYY-MM-DD");
        itm.EndDate = moment(item.EndDateShow).format("YYYY-MM-DD");
        let a = item.AvailabilityFromTime.split(":");
        itm.AvailabilityFromTime = +a[0] * 60 * 60 + +a[1] * 60;
        let b = item.AvailabilityToTime.split(":");
        itm.AvailabilityToTime = +b[0] * 60 * 60 + +b[1] * 60;
        return itm;
      })
      //this.settingsData.EventTimezone = ls.getSessionValueByKey("Session_Event_TZ");
      /* eslint-enable */
      let settingsData = {
        EventTimezone: ls.getSessionValueByKey("Session_Event_TZ"),
        ByTimezone: true,
        Duration: Number(this.settingsData.Slot),
        ExcludeGroupToRequestMeeting: this.settingsData.ExcludeGroupToRequestMeeting,
        MeetingRestrictionEnabled: this.settingsData.MeetingRestrictionEnabled,
        BookMeetingURL: this.settingsData.BookMeetingURL,
        StreamingClient: this.settingsData.StreamingClient,
        NotificationMessage: this.settingsData.NotificationMessage,
        Items: Items,
        /*AvailabilityFromTime: AvailabilityFromTime,
        AvailabilityToTime: AvailabilityToTime,
        StartDate: StartDate,
        EndDate: EndDate*/
      }
      this.$vs.loading();
      this.$store
        .dispatch("meetingManagement/saveSettings", {
          settingsData: settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$vs.loading.close();
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord() {
      this.$router.push("/event/meeting/add").catch(() => {});
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("meetingManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("meetingManagement/fetchMeetings");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    deleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete`,
        accept: this.deleteRecords,
        acceptText: "Delete",
      });
    },
       deleteRecord2() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete`,
        accept: this.deleteRecords2,
        acceptText: "Delete",
      });
    },
    deleteRecords() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("meetingManagement/removeMultiRecords", {
            data: selectedRows,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Delete",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            //this.$store.dispatch("meetingManagement/fetchAttendees");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
        deleteRecords2() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("meetingManagement/removeMultiRecords2", {
            data: selectedRows,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Delete",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            //this.$store.dispatch("meetingManagement/fetchAttendees");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    UploadMeeting: function () {
      var files = document.getElementById("meeting_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "meeting");
    },
    exportAttendance(){
      this.$vs.loading();
      this.$store.dispatch("meetingManagement/getMeetingStat").then((res) => {
        this.$vs.loading.close();
        let selectedRows = res;
        if (selectedRows.length > 0) {
            var datarow = [];
            datarow.push("MeetingId");
            datarow.push("Scheduled Meeting Date & time");
            datarow.push("Participant1 Name");
            datarow.push("Participant1 Email");
            datarow.push("Participant1 Join Time");            
            datarow.push("Participant1 Leave Time");
            datarow.push("Participant1 Meeting Duration(Minutes)");
            datarow.push("Participant2 Name");
            datarow.push("Participant2 Email");
            datarow.push("Participant2 Join Time");
            datarow.push("Participant2 Leave Time");
            datarow.push("Participant2 Meeting Duration(Minutes)");
            var AttendeeData = [];
            AttendeeData.push(datarow);
            selectedRows.forEach(row => {
              //row.Participances.forEach((item) => {
                if(row.Participances.length > 0){
                  datarow = [];
                  datarow.push('"' + row.MeetingId + '"');
                  datarow.push(row.Start ? moment(row.Start).tz(Session_Event_TZ).format("YYYY-MM-DD H:mm") : "N/A");
                  let Participant1_Name = 'N/A'
                  let Participant1_Email = 'N/A'
                  if(row.Participances[0]){
                    Participant1_Name = row.Participances[0].Name;
                    Participant1_Email = row.Participances[0].Email;
                    if(row.Participances[0].Email == row.Requestor.Email)
                      Participant1_Name = Participant1_Name + ' (Requestor)'
                    else if(row.Participances[0].Name && row.Participances[0].Name == row.Requestor.Name)
                      Participant1_Name = Participant1_Name + ' (Requestor)'
                    else if(row.Participances[0].Email == row.Invitee.Email)
                      Participant1_Name = Participant1_Name + ' (Invitee)'
                    else if(row.Participances[0].Name && row.Participances[0].Name == row.Invitee.Name)
                      Participant1_Name = Participant1_Name + ' (Invitee)'

                    if(!row.Participances[0].Email && row.Participances[0].AttendeeId == row.Requestor.AttendeeId)
                      Participant1_Email = row.Requestor.Email
                    else if(!row.Participances[0].Email && row.Participances[0].AttendeeId == row.Invitee.AttendeeId)
                      Participant1_Email = row.Invitee.Email
                  }
                  datarow.push('"' + Participant1_Name + '"');                  
                  datarow.push('"' + Participant1_Email + '"');                  
                  datarow.push(row.Participances[0] ? moment(row.Participances[0].JoinTime).tz(Session_Event_TZ).format("YYYY-MM-DD H:mm") : "N/A");
                  datarow.push(row.Participances[0] ? moment(row.Participances[0].LeaveTime).tz(Session_Event_TZ).format("YYYY-MM-DD H:mm") : "N/A");
                  datarow.push(row.Participances[0] ? row.Participances[0].duration : "N/A");
                  let Participant2_Name = 'N/A'
                  let Participant2_Email = 'N/A'
                  if(row.Participances[1]){
                    Participant2_Name = row.Participances[1].Name;
                    Participant2_Email = row.Participances[1].Email;
                    if(row.Participances[1].Email == row.Requestor.Email)
                      Participant2_Name = Participant2_Name + ' (Requestor)'
                    else if(row.Participances[1].Name && row.Participances[1].Name == row.Requestor.Name)
                      Participant2_Name = Participant2_Name + ' (Requestor)'
                    else if(row.Participances[1].Email == row.Invitee.Email)
                      Participant2_Name = Participant2_Name + ' (Invitee)'
                    else if(row.Participances[1].Name && row.Participances[1].Name == row.Invitee.Name)
                      Participant2_Name = Participant2_Name + ' (Invitee)'

                    if(!row.Participances[1].Email && row.Participances[1].AttendeeId == row.Requestor.AttendeeId)
                      Participant2_Email = row.Requestor.Email
                    else if(!row.Participances[1].Email && row.Participances[1].AttendeeId == row.Invitee.AttendeeId)
                      Participant2_Email = row.Invitee.Email
                  }
                  datarow.push('"' + Participant2_Name + '"');
                  datarow.push('"' + Participant2_Email + '"');
                  datarow.push(row.Participances[1] ? moment(row.Participances[1].JoinTime).tz(Session_Event_TZ).format("YYYY-MM-DD H:mm") : "N/A");
                  datarow.push(row.Participances[1] ? moment(row.Participances[1].LeaveTime).tz(Session_Event_TZ).format("YYYY-MM-DD H:mm") : "N/A");
                  datarow.push(row.Participances[1] ? row.Participances[1].duration : "N/A");
                  AttendeeData.push(datarow);
                }
              //});
            });

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "MeetingAttendanceReport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
      }).catch(err=>{ this.$vs.loading.close(); })
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];

        datarow.push("Meeting Id");
        datarow.push("Requested By");
        datarow.push("Requested By Email");
        datarow.push("Requested By Company");
        datarow.push("Requested By Country");
        datarow.push("Registration Type");
        datarow.push("Requested To");
        datarow.push("Requested To Email");
        datarow.push("Requested To Company");
        datarow.push("Requested To Country");
        datarow.push("Registration Type");
        datarow.push("Type");
        datarow.push("Date");
        datarow.push("Slot Date Time");
        datarow.push("Status");
        var AttendeeData = [];
        AttendeeData.push(datarow);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var MeetingId = row.MeetingId == undefined ? "" : row.MeetingId;
          datarow.push(MeetingId);

          var AttendeeName =
            row.Requestor.Name == undefined ? "" : row.Requestor.Name.replace('#','');
          datarow.push(AttendeeName);


          var AttendeeEmail =
            row.Requestor.Email == undefined ? "" : row.Requestor.Email;

          datarow.push(AttendeeEmail);


          var AttendeeCompany =
            row.Requestor.Company == undefined ? "" : row.Requestor.Company.replace('#','');
          datarow.push('"' + AttendeeCompany + '"');

          var attendeeCountry;
          this.attendeeData.map((attendee) => {
            if (row.Requestor.Email == attendee.Email) {
              attendeeCountry =
                attendee.Country ? attendee.Country : "NA";
            }
          });


          datarow.push('"' + attendeeCountry + '"');

          var RequestorRegisterType;
          this.attendeeData.map((attendee) => {
            if (row.Requestor.Email == attendee.Email) {
              RequestorRegisterType = attendee.RegistrationType;
            }
          });
          if (typeof RequestorRegisterType === "object") {
            datarow.push(RequestorRegisterType.RegistrationType);
          } else {
            datarow.push(RequestorRegisterType);
          }

          var RequestedTo =
            row.Invitee.Name == undefined ? "" : row.Invitee.Name.replace('#','');
          datarow.push(RequestedTo);

          var RequestedToEmail =
            row.Invitee.Email == undefined ? "" : row.Invitee.Email;
          datarow.push(RequestedToEmail);

          var RequestedToCompany =
            row.Invitee.Company == undefined ? "" : row.Invitee.Company.replace('#','');

          datarow.push('"' + RequestedToCompany + '"');
          

          var InviteeCountry;
          this.attendeeData.map((attendee) => {
            if (row.Invitee.Email == attendee.Email) {
              InviteeCountry = attendee.Country ? attendee.Country : "NA";
            }
          });


          datarow.push('"' + InviteeCountry + '"');

          var InviteeRegisterType;
          this.attendeeData.map((attendee) => {
            if (row.Invitee.Email == attendee.Email) {
              InviteeRegisterType = attendee.RegistrationType;
            }
          });

          if (typeof InviteeRegisterType === "object") {
            datarow.push(InviteeRegisterType.RegistrationType);
          } else {
            datarow.push(InviteeRegisterType);
          }

          var MeetingType = row.MeetingType == undefined ? "" : row.MeetingType;
          datarow.push(MeetingType);
          var StartDateTime =
            row.CreateDateTime == undefined
              ? ""
              : this.SetTimeByZone(
                  new Date(row.CreateDateTime._seconds * 1000).toUTCString(),
                  Session_Event_TZ
                );
          datarow.push(StartDateTime);

          var slotDateTime =
            row.Slots == undefined
              ? ""
              : this.SetTimeByZoneAMPM(
                  new Date(row.Slots[0]).toUTCString(),
                  Session_Event_TZ
                );
          var date = slotDateTime;
          datarow.push('"' + date + '"');
          var Status = row.Status == undefined ? "" : row.Status;
          datarow.push(Status);
          AttendeeData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "MeetingExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one record to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    getAttendees() {
      if (this.searchAttendeeText) {
        this.attendessList = [];
        this.$store
          .dispatch("attendeeManagement/searchAttendeesApi", {
            value: this.searchAttendeeText,
          })
          .then((res) => {
            //this.attendessList = res;
            if (res.status == 200) {              
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].IsPublished) {
                  this.attendessList.push({
                    AttendeeId: res.data[i].AttendeeId,
                    Email: res.data[i].Email,
                    FirstName: res.data[i].FirstName
                      ? res.data[i].FirstName
                      : "",
                    LastName: res.data[i].LastName ? res.data[i].LastName : "",
                    Name: res.data[i].Name ? res.data[i].Name : "",
                    Meetings: res.data[i].Meetings ? res.data[i].Meetings : [],
                  });
                }
              }
            }
          });
      }
    },
    convertZoomMeeting(Meetings = []){
      if(Meetings.length){
        this.$vs.loading();
        this.$store.dispatch("meetingManagement/convertO2OZoomMeeting", Meetings).then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {  
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: res.message,
            });      
          }
          else
          {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Meetings Not Converted to Zoom!",
            }); 
          }
        }).catch(err=>{ this.$vs.loading.close(); })
      }
    }
  },
  mounted() {
    self = this;
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    this.fetchAttendeeData();
  },
  created() {
    vm = this;
    if (!moduleMeetingManagement.isRegistered) {
      this.$store.registerModule("meetingManagement", moduleMeetingManagement);
      moduleMeetingManagement.isRegistered = true;
    }
    this.$vs.loading();
    this.$store.dispatch("meetingManagement/getSettings").then((res) => {
      if (res) {
        this.settingsData = res;
        this.settingsData.Slot = res.Duration;
        if(res.Items && res.Items.length){            
          res.Items.filter(item=>{
            item.ReadOnlyField = vm.meetingData.length ? true : false;
            item.StartDateShow = item.StartDate
              ? this.SetTimeByZone(
                  new Date(item.StartDate._seconds * 1000).toUTCString(),
                  Intl.DateTimeFormat().resolvedOptions().timeZone
                )
              : null;
            item.EndDateShow = item.EndDate
              ? this.SetTimeByZone(
                  new Date(item.EndDate._seconds * 1000).toUTCString(),
                  Intl.DateTimeFormat().resolvedOptions().timeZone
                )
              : null;
            item.AvailabilityFromTime = item.AvailabilityFromTime
              ? this.getTimeFromSecond(item.AvailabilityFromTime)
              : "00:00";
            item.AvailabilityToTime = item.AvailabilityToTime
              ? this.getTimeFromSecond(item.AvailabilityToTime)
              : "00:00";
          });
          this.Items = res.Items
        }
      }
      this.$store.dispatch("meetingManagement/fetchMeetings").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      });
    });
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
     this.$store.dispatch("attendeeManagement/fetchAttendees");
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.$store.dispatch("agendaManagement/fetchGroups").then(function (res) {
      vm.GroupList = res.map((row) => {
        return {
          GroupId: row.GroupId,
          GroupName: row.GroupName,
        };
      });
    });
    this.fetch_meetingLocation();
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.$store.dispatch("eventManagement/fetchEventMenu", ls.getSessionValueByKey("Session_Event_Id")).then((res) => {
      vm.AvailableMenu = res.AvailableMenu.filter(item=> [1001,1005].includes(Number(item.MenuID)) );
    })
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>